import * as i0 from '@angular/core';
import { InjectionToken, EventEmitter, ViewChild, Output, Input, Optional, Inject, Component, NgModule } from '@angular/core';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from 'angular-gridster2';
import { CompactType, GridType, GridsterModule } from 'angular-gridster2';
import * as i13 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i15 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i14 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i10 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i11 from '@azavista/components/widgets';
import { AzavistaWidgetDialogComponent, AzavistaWidgetsModule } from '@azavista/components/widgets';
import { AzavistaMultiSelectDialogComponent, AzavistaMultiSelectDialogModule } from '@azavista/components/multi-select-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import bsonObjectId from 'bson-objectid';
import * as i12 from '@azavista/components/exported-element';
import { AzavistaExportedElementExporterDirective, AzavistaExportedElementModule } from '@azavista/components/exported-element';
import * as i1 from '@angular/material/dialog';
import * as i2 from '@angular/router';
import * as i3 from '@azavista/components/shared';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i8 from '@angular/forms';
import * as i9 from '@ngx-translate/core';
const _c0 = ["gridster"];
function DashboardComponent_div_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DashboardComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "h1", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DashboardComponent_div_0_ng_container_3_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const addWidgetButtonTemplate_r3 = i0.ɵɵreference(39);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.dashboardTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", addWidgetButtonTemplate_r3);
  }
}
function DashboardComponent_mat_option_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dashboard_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", dashboard_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(dashboard_r4.name);
  }
}
function DashboardComponent_ng_container_22_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DashboardComponent_ng_container_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DashboardComponent_ng_container_22_ng_container_1_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const addWidgetButtonTemplate_r3 = i0.ɵɵreference(39);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", addWidgetButtonTemplate_r3);
  }
}
function DashboardComponent_mat_option_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const compactOption_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", compactOption_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, compactOption_r5.label), " ");
  }
}
function DashboardComponent_p_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 24)(1, "span", 7);
    i0.ɵɵtext(2, "NO_DASHBOARDS_WARNING");
    i0.ɵɵelementEnd()();
  }
}
function DashboardComponent_gridster_item_34_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "img", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.widgetDataLoadingImageUrl, i0.ɵɵsanitizeUrl);
  }
}
function DashboardComponent_gridster_item_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "gridster-item", 25)(1, "div", 26);
    i0.ɵɵtemplate(2, DashboardComponent_gridster_item_34_div_2_Template, 2, 1, "div", 27);
    i0.ɵɵelementStart(3, "div", 28)(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 29);
    i0.ɵɵlistener("click", function DashboardComponent_gridster_item_34_Template_button_click_6_listener() {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.widgetMenuSelected(i_r7));
    });
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "more_vert");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "azavista-widget-placeholder", 30);
    i0.ɵɵlistener("loading", function DashboardComponent_gridster_item_34_Template_azavista_widget_placeholder_loading_9_listener($event) {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onWidgetLoading(i_r7, $event));
    })("settingsNeeded", function DashboardComponent_gridster_item_34_Template_azavista_widget_placeholder_settingsNeeded_9_listener() {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSettingsNeeded(i_r7));
    })("customEvent", function DashboardComponent_gridster_item_34_Template_azavista_widget_placeholder_customEvent_9_listener($event) {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onWidgetCustomEvent(i_r7, $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    const widgetActionsMenu_r9 = i0.ɵɵreference(36);
    i0.ɵɵproperty("item", item_r8);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.getWidgetInfo(i_r7).loading);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.widgets[i_r7] == null ? null : ctx_r1.widgets[i_r7].title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("matMenuTriggerFor", widgetActionsMenu_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("definition", ctx_r1.widgets[i_r7]);
  }
}
function DashboardComponent_ng_template_37_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 33);
    i0.ɵɵlistener("click", function DashboardComponent_ng_template_37_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.viewDetails(ctx_r1.selectedWidgetMenuIndex));
    });
    i0.ɵɵelementStart(1, "mat-icon", 34);
    i0.ɵɵtext(2, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 33);
    i0.ɵɵlistener("click", function DashboardComponent_ng_template_37_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showWidgetConfig(ctx_r1.selectedWidgetMenuIndex));
    });
    i0.ɵɵelementStart(5, "mat-icon", 34);
    i0.ɵɵtext(6, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 33);
    i0.ɵɵlistener("click", function DashboardComponent_ng_template_37_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.deleteSelectedWidget(ctx_r1.selectedWidgetMenuIndex));
    });
    i0.ɵɵelementStart(10, "mat-icon", 34);
    i0.ɵɵtext(11, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabledWidgetActions == null ? null : ctx_r1.disabledWidgetActions.view);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", (ctx_r1.disabledWidgetActions == null ? null : ctx_r1.disabledWidgetActions.view) ? "" : "primary");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getViewButtonText(ctx_r1.selectedWidgetMenuIndex), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.disabledWidgetActions == null ? null : ctx_r1.disabledWidgetActions.edit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", (ctx_r1.disabledWidgetActions == null ? null : ctx_r1.disabledWidgetActions.edit) ? "" : "primary");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, "EDIT"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.disabledWidgetActions == null ? null : ctx_r1.disabledWidgetActions.delete);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", (ctx_r1.disabledWidgetActions == null ? null : ctx_r1.disabledWidgetActions.delete) ? "" : "warn");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 11, "DELETE"), " ");
  }
}
function DashboardComponent_ng_template_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 10);
    i0.ɵɵlistener("click", function DashboardComponent_ng_template_38_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addWidget());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4, "ADD_WIDGET");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r1.dashboards.length || ctx_r1.disableAddWidget);
  }
}
const AZAVISTA_COMPONENTS_DASHBOARD_DEFAULT_OPTIONS = new InjectionToken('azavista-components-dashboard-default-options');
const NG_GRIDSTER_COMPACT_OPTIONS = [{
  value: CompactType.None,
  label: 'NONE'
}, {
  value: CompactType.CompactUp,
  label: 'UP'
}, {
  value: CompactType.CompactUpAndLeft,
  label: 'UP_AND_LEFT'
}, {
  value: CompactType.CompactUpAndRight,
  label: 'UP_AND_RIGHT'
}, {
  value: CompactType.CompactRight,
  label: 'RIGHT'
}, {
  value: CompactType.CompactRightAndUp,
  label: 'RIGHT_AND_UP'
}, {
  value: CompactType.CompactLeft,
  label: 'LEFT'
}, {
  value: CompactType.CompactLeftAndUp,
  label: 'LEFT_AND_UP'
}];
let DashboardComponent = /*#__PURE__*/(() => {
  class DashboardComponent extends AzavistaExportedElementExporterDirective {
    constructor(matDialog, router, translateSvc, ngZone, dеfaultOptions) {
      super(ngZone);
      this.matDialog = matDialog;
      this.router = router;
      this.translateSvc = translateSvc;
      this.ngZone = ngZone;
      this.dеfaultOptions = dеfaultOptions;
      this.dashboardTitle = '';
      this.availableWidgets = [];
      this.layout = [];
      this.widgets = [];
      this.widgetDataLoadingImageUrl = '';
      this.disableAddWidget = false;
      this.disableEditDashboard = false;
      this.disableCreateDashboard = false;
      this.dashboardChanged = new EventEmitter();
      this.dashboardSelected = new EventEmitter();
      this.editDashboard = new EventEmitter();
      this.createDashboard = new EventEmitter();
      this.widgetCustomEvent = new EventEmitter();
      this.widgetsInfo = [];
      this.compactOptions = NG_GRIDSTER_COMPACT_OPTIONS;
      this.itemsChanged$ = new Subject();
      this.destroyed$ = new Subject();
    }
    async ngOnInit() {
      this.selectedDashboard = this.dashboards.find(x => x.id === this.activeDashboardId);
      this.applyDefaultOptions();
      this.unifyLayoutAndWidgets();
      this.defaultGridsterConfig = {
        itemChangeCallback: (item, itemComponent) => this.onItemChange(item, itemComponent),
        itemResizeCallback: (item, itemComponent) => this.onItemResize(item, itemComponent),
        gridSizeChangedCallback: gridster => this.onGridSizeChanged(gridster),
        resizable: {
          enabled: true
        },
        draggable: {
          enabled: true
        },
        gridType: GridType.Fixed,
        fixedColWidth: 385,
        fixedRowHeight: 300,
        compactType: CompactType.CompactUpAndLeft,
        setGridSize: true,
        minCols: 4,
        maxCols: 4,
        minRows: 4,
        maxRows: 10,
        pushItems: true,
        // false to not auto-expand grid on drag-drop over other items
        ...this.gridsterConfig
      };
      this.itemsChanged$.pipe(takeUntil(this.destroyed$)).subscribe({
        next: () => {
          // If this.layout has less items than this.gridster.grid, then widget was removed
          // and grid will reflect this after the Angular change detection
          // In this case we must use this.layout since it is the correct one, not what we see on the screen
          // In other cases we need this.gridster.grid since it could be item resize or move where the count
          // of the two lengths will be the same
          const layout = this.getLayout();
          this.dashboardChanged.emit({
            layout,
            widgets: this.widgets,
            compactType: this.defaultGridsterConfig.compactType
          });
        }
      });
    }
    ngOnChanges(changes) {
      if (changes.layout || changes.widgets) {
        this.unifyLayoutAndWidgets();
      }
    }
    getLayout() {
      return this.layout.length < this.gridster.grid.length ? this.layout : this.gridster.grid.map(x => x.$item);
    }
    changedOptions() {
      if (this.defaultGridsterConfig.api?.optionsChanged) {
        this.defaultGridsterConfig.api?.optionsChanged();
      }
    }
    onWidgetAlignmentChanged() {
      this.changedOptions();
      this.dashboardChanged.emit({
        widgets: this.widgets,
        layout: this.getLayout(),
        compactType: this.defaultGridsterConfig.compactType
      });
    }
    viewDetails(selectedWidget) {
      const widgetDefinition = {
        ...this.widgets[selectedWidget]
      };
      if (widgetDefinition.viewDetailsNavPath) {
        this.router.navigate([widgetDefinition.viewDetailsNavPath], {
          queryParams: {
            ...widgetDefinition.viewDetailsNavQueryParams
          }
        });
      }
    }
    getViewButtonText(selectedWidget) {
      const widgetDefinition = {
        ...this.widgets[selectedWidget]
      };
      return widgetDefinition.viewButtonText || this.translateSvc.getTranslation('VIEW_DETAILS');
    }
    onDashboardSelected(dashboard) {
      this.dashboardSelected.emit(dashboard);
    }
    onCreateDashboardClicked() {
      this.createDashboard.emit();
    }
    onEditDashboardClicked() {
      this.editDashboard.emit(this.selectedDashboard);
    }
    unifyLayoutAndWidgets() {
      if (this.layout.length === this.widgets.length) {
        // Layout contains exact number of items as widgets - no unification is needed
        return;
      }
      // Dashboard cannot work with inconsistent count of layout items and widgets
      // Both arrays must have equal lengths according to the shorter array
      const shorterLength = Math.min(this.layout.length, this.widgets.length);
      this.layout = this.layout.slice(0, shorterLength);
      this.widgets = this.widgets.slice(0, shorterLength);
    }
    applyDefaultOptions() {
      if (this.dеfaultOptions) {
        this.widgetDataLoadingImageUrl = this.widgetDataLoadingImageUrl || this.dеfaultOptions.widgetDataLoadingImageUrl;
      }
    }
    ngOnDestroy() {
      this.destroyed$.next();
      this.destroyed$.complete();
    }
    widgetMenuSelected(index) {
      this.selectedWidgetMenuIndex = index;
    }
    getWidgetInfo(index) {
      const widgetId = this.widgets[index].id;
      let widgetInfo = this.widgetsInfo.find(x => x.id === widgetId);
      if (!widgetInfo) {
        widgetInfo = {
          id: widgetId,
          manualyAdded: false,
          loading: false
        };
        this.widgetsInfo.push(widgetInfo);
      }
      return widgetInfo;
    }
    onWidgetLoading(widgetDefinitionIndex, loading) {
      const widgetInfo = this.getWidgetInfo(widgetDefinitionIndex);
      window.setTimeout(() => {
        widgetInfo.loading = loading;
      });
    }
    onWidgetCustomEvent(widgetDefinitionIndex, args) {
      const widgetComponentDefinition = this.widgets[widgetDefinitionIndex];
      this.widgetCustomEvent.next({
        widgetComponentDefinition: widgetComponentDefinition,
        widgetCustomEventArgs: args
      });
    }
    onSettingsNeeded(index) {
      // Show widget config only for those that were manually added
      // Other widgets could also report settings needed but those are probably already existing
      // with empty settings that came from the server - in order to avoid settings dialog for these
      // only manually added will show their settings dialog
      const widgetInfo = this.getWidgetInfo(index);
      if (widgetInfo.manualyAdded) {
        this.showWidgetConfig(index).afterClosed().subscribe({
          next: dialogResult => {
            if (!dialogResult || dialogResult.action === 'close') {
              // Dialog was closed wihout providing settings
              // We must to remove this widget
              this.deleteSelectedWidget(index);
            }
          }
        });
      }
    }
    addWidget() {
      const data = {
        title: this.translateSvc.getTranslation("CHOOSE_AN_EXISTING_WIDGET_DIALOG_TITLE" /* Translations.chooseAnExistingWidgetDialogTitle */),
        subTitle: this.translateSvc.getTranslation("SELECT_A_REPORTING_WIDGET_DIALOG_SUBTITLE" /* Translations.chooseAnExistingWidgetDialogSubtitle */),
        items: [...this.availableWidgets].map(item => ({
          ...item
        })),
        singleSelection: true
      };
      this.matDialog.open(AzavistaMultiSelectDialogComponent, {
        data: data,
        minWidth: '40%',
        maxWidth: '80%'
      }).afterClosed().pipe(takeUntil(this.destroyed$)).subscribe({
        next: value => this.processAddWigetDialogResult(value)
      });
    }
    processAddWigetDialogResult(value) {
      if (!value) {
        return;
      }
      value.items.filter(x => x.selected).forEach(item => {
        const widget = {
          ...item.definition,
          id: bsonObjectId().toHexString(),
          dataChangedSubject: new Subject(),
          settings: {
            local: {
              ...(item.definition.settings && item.definition.settings.local)
            },
            remote: {
              ...(item.definition.settings && item.definition.settings.remote)
            }
          }
        };
        this.layout.push({});
        this.widgets.push(widget);
        this.widgetsInfo.push({
          id: widget.id,
          manualyAdded: true,
          loading: false
        });
        this.itemsChanged$.next();
      });
    }
    showWidgetConfig(selectedWidget) {
      const data = {
        actionSubject: new Subject(),
        widgetDefinition: {
          ...this.widgets[selectedWidget]
        },
        settingsAreValid: false
      };
      const dialogRef = this.matDialog.open(AzavistaWidgetDialogComponent, {
        data: data,
        minWidth: '700px'
      });
      const subscription$ = data.actionSubject.subscribe({
        next: dialogResult => {
          subscription$.unsubscribe();
          dialogRef.close(dialogResult);
          if (dialogResult.action === 'save') {
            this.onWidgetSettingsChanged({
              definition: dialogResult.data.widgetDefinition,
              settings: dialogResult.data.widgetDefinition.settings,
              settingsAreValid: dialogResult.data.settingsAreValid
            });
          }
        }
      });
      return dialogRef;
    }
    deleteSelectedWidget(selectedWidget) {
      // gridster.grid is changed by the gridster itself when the array for "<gridster-item *ngFor="let item of layout..."
      // is changed from the code - we don't need to manually change it because this causes troubles by removing
      // also the item before the removed one from this.layout
      // this.gridster.grid = this.gridster.grid.filter((_, index) => selectedWidget !== index);
      this.layout = this.layout.filter((_, index) => selectedWidget !== index);
      this.widgets = this.widgets.filter((_, index) => selectedWidget !== index);
      this.widgetsInfo = this.widgetsInfo.filter((_, index) => selectedWidget !== index);
      this.itemsChanged$.next();
    }
    onWidgetSettingsChanged(changedValue) {
      const index = this.widgets.findIndex(x => x.id === changedValue.definition.id);
      const definition = this.widgets[index];
      if (!definition) {
        return;
      }
      definition.title = changedValue.definition.title;
      definition.settings = {
        ...changedValue.settings
      };
      definition.viewDetailsNavPath = changedValue.definition.viewDetailsNavPath;
      definition.viewDetailsNavQueryParams = changedValue.definition.viewDetailsNavQueryParams;
      definition.viewButtonText = changedValue.definition.viewButtonText;
      definition.dataChangedSubject.next({
        settings: changedValue.settings,
        title: changedValue.definition.title,
        viewDetailsNavPath: changedValue.definition.viewDetailsNavPath,
        viewDetailsNavQueryParams: changedValue.definition.viewDetailsNavQueryParams,
        viewButtonText: changedValue.definition.viewButtonText
      });
      this.itemsChanged$.next();
    }
    onGridSizeChanged(gr) {}
    onItemChange(item, itemComponent) {
      // This is the place where we should save the dashboard
      // It could be called multiple times so only the last one must be used
      // Use observable that emits the last value only when there are no emits for more than a second
      this.itemsChanged$.next();
    }
    onItemResize(item, itemComponent) {
      const index = this.layout.findIndex(x => x === item);
      const newItem = itemComponent.$item;
      const unusedHeight = 32 + 12;
      const unusedWidth = 12;
      const cellWidth = (newItem.cols || 1) * this.gridster.curColWidth;
      const cellHeight = (newItem.rows || 1) * this.gridster.curRowHeight;
      const newWidth = cellWidth - unusedWidth;
      const newHeight = cellHeight - unusedHeight;
      const definition = this.widgets[index];
      definition.dataChangedSubject.next({
        width: newWidth,
        height: newHeight
      });
      definition.size = {
        width: newWidth,
        height: newHeight
      };
      this.itemsChanged$.next();
    }
    static {
      this.ɵfac = function DashboardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DashboardComponent)(i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i3.TranslationService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(AZAVISTA_COMPONENTS_DASHBOARD_DEFAULT_OPTIONS, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DashboardComponent,
        selectors: [["azavista-dashboard"]],
        viewQuery: function DashboardComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.gridster = _t.first);
          }
        },
        inputs: {
          dashboardTitle: "dashboardTitle",
          activeDashboardId: "activeDashboardId",
          dashboards: "dashboards",
          gridsterConfig: "gridsterConfig",
          availableWidgets: "availableWidgets",
          layout: "layout",
          widgets: "widgets",
          widgetDataLoadingImageUrl: "widgetDataLoadingImageUrl",
          disableAddWidget: "disableAddWidget",
          disableEditDashboard: "disableEditDashboard",
          disableCreateDashboard: "disableCreateDashboard",
          disabledWidgetActions: "disabledWidgetActions"
        },
        outputs: {
          dashboardChanged: "dashboardChanged",
          dashboardSelected: "dashboardSelected",
          editDashboard: "editDashboard",
          createDashboard: "createDashboard",
          widgetCustomEvent: "widgetCustomEvent"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 40,
        vars: 17,
        consts: [["gridster", ""], ["widgetActionsMenu", "matMenu"], ["addWidgetButtonTemplate", ""], ["class", "title-container aza-cmp-flex-row aza-cmp-content-space-between", 4, "ngIf"], [1, "actions-container", "dashboard-actions-container", "aza-cmp-flex-row", "aza-cmp-content-space-between", "aza-cmp-rounded-border"], [1, "dashboard-selector", "aza-cmp-flex-row"], [1, "aza-cmp-medium-width"], ["translate", ""], [3, "ngModelChange", "selectionChange", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], ["color", "primary", 3, "click", "disabled"], [1, "material-icons-outlined"], [4, "ngIf"], [1, "dashboard-config-options"], [3, "ngModelChange", "ngModel"], ["class", "no-dashboards-warning", 4, "ngIf"], [1, "widgets-grid-container"], [3, "options"], [3, "item", 4, "ngFor", "ngForOf"], ["matMenuContent", ""], [1, "title-container", "aza-cmp-flex-row", "aza-cmp-content-space-between"], [1, "dashboard-title"], [4, "ngTemplateOutlet"], [3, "value"], [1, "no-dashboards-warning"], [3, "item"], [1, "widget-header", "aza-cmp-flex-row"], ["class", "widget-loading", 4, "ngIf"], [1, "widget-title-menu", "aza-cmp-flex-row", "aza-cmp-flex-item-grow", "aza-cmp-flex-item-content-end"], ["mat-icon-button", "", 3, "click", "matMenuTriggerFor"], [3, "loading", "settingsNeeded", "customEvent", "definition"], [1, "widget-loading"], [1, "widget-loading-img", 3, "src"], ["mat-menu-item", "", 3, "click", "disabled"], ["matPrefix", "", 3, "color"]],
        template: function DashboardComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, DashboardComponent_div_0_Template, 4, 2, "div", 3);
            i0.ɵɵelementStart(1, "azavista-exported-element-wrapper")(2, "div", 4)(3, "div", 5)(4, "mat-form-field", 6)(5, "mat-label")(6, "span", 7);
            i0.ɵɵtext(7, "DASHBOARD");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "mat-select", 8);
            i0.ɵɵtwoWayListener("ngModelChange", function DashboardComponent_Template_mat_select_ngModelChange_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedDashboard, $event) || (ctx.selectedDashboard = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("selectionChange", function DashboardComponent_Template_mat_select_selectionChange_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDashboardSelected($event.value));
            });
            i0.ɵɵtemplate(9, DashboardComponent_mat_option_9_Template, 2, 2, "mat-option", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "azavista-flat-button", 10);
            i0.ɵɵlistener("click", function DashboardComponent_Template_azavista_flat_button_click_10_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onEditDashboardClicked());
            });
            i0.ɵɵelementStart(11, "mat-icon", 11);
            i0.ɵɵtext(12, "edit");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "span");
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "azavista-flat-button", 10);
            i0.ɵɵlistener("click", function DashboardComponent_Template_azavista_flat_button_click_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCreateDashboardClicked());
            });
            i0.ɵɵelementStart(17, "mat-icon", 11);
            i0.ɵɵtext(18, "add");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "span");
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(22, DashboardComponent_ng_container_22_Template, 2, 1, "ng-container", 12);
            i0.ɵɵelementStart(23, "div", 13)(24, "mat-form-field")(25, "mat-label")(26, "span", 7);
            i0.ɵɵtext(27, "WIDGETS_ALIGNMENT");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "mat-select", 14);
            i0.ɵɵtwoWayListener("ngModelChange", function DashboardComponent_Template_mat_select_ngModelChange_28_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.defaultGridsterConfig.compactType, $event) || (ctx.defaultGridsterConfig.compactType = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function DashboardComponent_Template_mat_select_ngModelChange_28_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onWidgetAlignmentChanged());
            });
            i0.ɵɵtemplate(29, DashboardComponent_mat_option_29_Template, 3, 4, "mat-option", 9);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵtemplate(30, DashboardComponent_p_30_Template, 3, 0, "p", 15);
            i0.ɵɵelementStart(31, "div", 16)(32, "gridster", 17, 0);
            i0.ɵɵtemplate(34, DashboardComponent_gridster_item_34_Template, 10, 5, "gridster-item", 18);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(35, "mat-menu", null, 1);
            i0.ɵɵtemplate(37, DashboardComponent_ng_template_37_Template, 14, 13, "ng-template", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(38, DashboardComponent_ng_template_38_Template, 5, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.dashboardTitle);
            i0.ɵɵadvance(8);
            i0.ɵɵtwoWayProperty("ngModel", ctx.selectedDashboard);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.dashboards);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disableEditDashboard || !ctx.selectedDashboard || !ctx.dashboards.length);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 13, "EDIT_DASHBOARD"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disableCreateDashboard);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 15, "CREATE_DASHBOARD"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.dashboardTitle);
            i0.ɵɵadvance(6);
            i0.ɵɵtwoWayProperty("ngModel", ctx.defaultGridsterConfig.compactType);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.compactOptions);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.dashboards.length);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("options", ctx.defaultGridsterConfig);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.layout);
          }
        },
        dependencies: [i4.NgForOf, i4.NgIf, i4.NgTemplateOutlet, i5.MatMenu, i5.MatMenuItem, i5.MatMenuContent, i5.MatMenuTrigger, i6.MatIcon, i7.GridsterComponent, i7.GridsterItemComponent, i8.NgControlStatus, i8.NgModel, i9.TranslateDirective, i10.AzavistaButtonComponent, i10.AzavistaFlatButtonComponent, i11.AzavistaWidgetPlaceholderComponent, i12.AzavistaExportedElementWrapperComponent, i13.MatIconButton, i14.MatFormField, i14.MatLabel, i14.MatPrefix, i15.MatSelect, i15.MatOption, i9.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return DashboardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaDashboardModule = /*#__PURE__*/(() => {
  class AzavistaDashboardModule {
    static {
      this.ɵfac = function AzavistaDashboardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaDashboardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaDashboardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatMenuModule, MatIconModule, GridsterModule, AzavistaSharedModule, AzavistaMultiSelectDialogModule, AzavistaButtonModule, AzavistaWidgetsModule, AzavistaExportedElementModule, MatButtonModule, MatFormFieldModule, MatSelectModule]
      });
    }
  }
  return AzavistaDashboardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AZAVISTA_COMPONENTS_DASHBOARD_DEFAULT_OPTIONS, AzavistaDashboardModule, DashboardComponent, NG_GRIDSTER_COMPACT_OPTIONS };
